import { Inject, Injectable, InjectionToken } from "@angular/core";
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Observable } from "rxjs";
import { timeout } from "rxjs/operators";

export const DEFAULT_TIMEOUT = new InjectionToken<number>("defaultTimeout");

@Injectable()
export class TimeoutInterceptor implements HttpInterceptor {
    constructor(@Inject(DEFAULT_TIMEOUT) protected defaultTimeout: number) {}

    intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        if(request.headers.get("timeOut") === "false") {
            return next.handle(request);
        }
        const timeoutValue = request.headers.get("timeout") || this.defaultTimeout;
        const timeoutValueNumeric = Number(timeoutValue);
        return next.handle(request).pipe(timeout(timeoutValueNumeric));
    }
}
